module.exports = __webpack_public_path__ + "img/tranzactiicard.f6c639ff.svg";